import { render, staticRenderFns } from "./LedgerModal.vue?vue&type=template&id=3fd4a980"
import script from "./LedgerModal.vue?vue&type=script&lang=js"
export * from "./LedgerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports